<template>
  <div id="contract-document" class="overlay-content">
    <table width="100%">
      <tr>
        <td width="100%"  align="center">
          <p><img v-if="getCompanyLogo() !== ''" width="150px" alt="Contract Manager logo" :src="getCompanyLogo()" id="company-logo"></p>
        </td>
      </tr>
    </table>
    <table width="100%" style="margin-bottom: 30px;">
      <tr>
        <td width="80%" id="contract-header" style="padding-top: 50px">
          <table width="100%" style="padding: 0; margin: 0;">
            <tr>
              <td colspan="2" align="left">
                <p style="margin-bottom: 20px;"><strong>Ref code</strong>: {{contractDetail.refCode}}</p>
              </td>
            </tr>
            <tr>
              <td valign="top" width="50%">
                <contact-person
                  :agent="contractDetail.agent">
                </contact-person>
              </td>
              <td valign="top" width="50%">
                <sale-person
                  :sale-person="contractDetail.salePerson"
                  :hotel="hotel">
                </sale-person>
              </td>
            </tr>
          </table>
        </td>
        <td width="20%" valign="middle">
          <img v-if="hotel.logoUrl !== ''" width="150px" alt="Contract Manager logo" :src="hotel.logoUrl" id="hotel-logo">
        </td>
      </tr>
    </table>
    <div id="contract-detail">
      <div>
        <rate-code
          :rate-code-list="contractDetail.rateCodeList"
          :contract-start-date="contractDetail.startDate"
          :contract-end-date="contractDetail.endDate"
          :hotel-name="getHotelName()"
          :currency="companyData.currency"
          :remark-list="contractDetail.remarkList">
        </rate-code>
      </div>
      <div>
        <allotment
          :contract-start-date="contractDetail.startDate"
          :contract-end-date="contractDetail.endDate"
          :allotment-list="contractDetail.allotmentList"
          :cut-off-date-list="contractDetail.cutOffDateList"
          :remark-list="contractDetail.remarkList">
        </allotment>
      </div>
      <div>
        <promotion
          :contract-start-date="contractDetail.startDate"
          :contract-end-date="contractDetail.endDate"
          :promotion-list="contractDetail.promotionList"
          :remark-list="contractDetail.remarkList">
        </promotion>
      </div>
      <div>
        <supplement
          :contract-start-date="contractDetail.startDate"
          :contract-end-date="contractDetail.endDate"
          :supplement-list="contractDetail.supplementList"
          :supplement-type-list="supplementTypeList"
          :remark-list="contractDetail.remarkList">
        </supplement>
      </div>
      <div>
        <transfer
          :transfer-list="contractDetail.transferList"
          :remark-list="contractDetail.remarkList">
        </transfer>
      </div>
      <div v-if="hotel.remark !== undefined" style="margin-top: 60px;">
        <p class="avoid" v-html="bindHotelRemark(hotel.remark)"></p>
      </div>
      <div class="editor-preview" style="margin-bottom: 40px;" :style="{ marginTop: ((hotel.remark === undefined) ? '60px' : '0') }">
        <div class="avoid" v-html="bindContractRemark()"></div>
      </div>
      <div>
        <term-of-payment
          :terms-of-payment-format="getTermsOfPaymentFormat(companyData)"
          :data-list="contractDetail.termsOfPaymentList">
        </term-of-payment>
      </div>
    </div>
    <div id="terms-and-condition">
      <term-and-condition
        :data-list="getDataList(contractDetail.termAndCondition)"
        :hotel-name="getHotelName()">
      </term-and-condition>
    </div>
    <div>
      <br />
      <br />
      <signed :contract-detail="contractDetail"></signed>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'
import Signed from '@/views/Contract/components/PreviewContract/SingedComponent'
import TermOfPayment from '@/views/Contract/components/PreviewContract/TermOfPaymentComponent'
import TermAndCondition from '@/views/Contract/components/PreviewContract/TermAndConditionComponent'
import Transfer from '@/views/Contract/components/PreviewContract/TransferComponent'
import Supplement from '@/views/Contract/components/PreviewContract/SupplementComponent'
import Promotion from '@/views/Contract/components/PreviewContract/PromotionComponent'
import RateCode from '@/views/Contract/components/PreviewContract/RateCodeComponent'
import ContactPerson from '@/views/Contract/components/PreviewContract/ContactPersonComponent'
import SalePerson from '@/views/Contract/components/PreviewContract/SalePersonComponent'
import Allotment from '@/views/Contract/components/PreviewContract/AllotmentComponent'
import { REMARK_TYPE } from '@/configs/constant'
import { applyHotelRemarkTableStyle, applyRemarkTableStyle } from '@/domains/contract-domain'

export default {
  name: 'DocumentContainerComponent',
  components: {
    Signed,
    TermOfPayment,
    TermAndCondition,
    Transfer,
    Supplement,
    Promotion,
    RateCode,
    ContactPerson,
    SalePerson,
    Allotment
  },
  props: {
    contractDetail: {
      type: Object,
      default: () => {
        return {
          id: '',
          hotel: {},
          refCode: '',
          startDate: '',
          endDate: '',
          salePerson: {},
          contactPerson: {},
          internalNote: '',
          agent: {},
          status: 1,
          rateCodeList: [],
          allotmentList: [],
          promotionList: [],
          supplementList: [],
          transferList: [],
          termsOfPaymentList: [],
          termAndCondition: {
            dataList: []
          }
        }
      }
    },
    supplementTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    hotel: {
      type: Object,
      default: () => {
        return {}
      }
    },
    companyData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    getCompanyLogo: function () {
      const logoUrl = get(this.companyData, 'logoUrl', '')

      return logoUrl
    },
    getDataList: function (dataObj) {
      const dataList = get(dataObj, 'dataList', [])

      return dataList
    },
    getTermsOfPaymentFormat: function (companyData) {
      const defaultTermsOfPaymentFormat = {
        align: 'left',
        multiline: true
      }
      const termsOfPaymentFormat = get(companyData, 'documentFormat.termOfPayment', defaultTermsOfPaymentFormat)

      return termsOfPaymentFormat
    },
    getHotelName: function () {
      const hotelName = get(this.hotel, 'name', '-')

      return hotelName
    },
    bindHotelRemark: function (hotelRemark) {
      const remark = hotelRemark.replace(/(?:\r\n|\r|\n)/g, '<br>')
      const appliedRemark = applyHotelRemarkTableStyle(remark)

      return appliedRemark
    },
    bindContractRemark: function () {
      const remarkList = get(this.contractDetail, 'remarkList', [])
      const remark = applyRemarkTableStyle(remarkList, REMARK_TYPE.CONTRACT)

      return remark
    }
  }
}
</script>
<style scoped>
  .overlay-content {
    position: relative;
    top: 10%;
    margin-top: 30px;
    overflow-y: scroll;
    font-size: 18px;
    width: calc(100% - 200px);
    padding-left: 100px;
    padding-right: 100px;
    padding-bottom: 100px;
  }

  .editor-preview .table {
    margin: 0;
  }

  .editor-preview table {
    width: 100%;
  }
</style>
